import styled from 'styled-components'

export const ReportsRequestedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
